import styled from 'styled-components';
import { COLORS, monoValue } from '../../lib/theme';
import { MEDIA_MODES } from '../../hooks/useMediaMode';

const Group = styled.div`
  display: inline-flex;
  border: 1px solid ${COLORS.hairline};
`;

// The selected segment inverts to a solid steel fill rather than going
// yellow: the header this sits in already spends its one accent on the cam
// id.
const Segment = styled.button`
  ${monoValue}
  font-size: 9px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 2px 7px;
  cursor: pointer;
  border: 0;
  color: ${(p) => (p.$selected ? COLORS.ground : COLORS.label)};
  background: ${(p) => (p.$selected ? COLORS.text : 'transparent')};

  & + & {
    border-left: 1px solid ${COLORS.hairline};
  }

  &:hover {
    color: ${(p) => (p.$selected ? COLORS.ground : COLORS.text)};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${COLORS.ground}, 0 0 0 4px ${COLORS.accent};
  }
`;

/**
 * PHOTO | VIDEO. Display-only: it changes which existing file each camera
 * panel shows, and nothing here can ask the device to take one.
 */
export default function ModeSwitch({ mode, onChange }) {
  return (
    <Group role="radiogroup" aria-label="Media mode">
      {MEDIA_MODES.map((m) => (
        <Segment
          key={m}
          type="button"
          role="radio"
          aria-checked={mode === m}
          $selected={mode === m}
          onClick={() => onChange(m)}
        >
          {m}
        </Segment>
      ))}
    </Group>
  );
}
